module.exports = __webpack_public_path__ + "img/report-12318.9dcccd67.9dcccd67.png";